PJQ.views.submittals.SubmittalsView = PJQ.views.BaseView.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.SUBMITTALS, 'submittals-management'),
        initSubmittalId: null
    },
    events: {
        'click .btn-delete-submittal': 'deleteClicked',
        'click .btn-edit-submittal': 'editClicked',
        'click .btn-add-submittal': 'addClicked',
        'click .export-detailed': 'exportSubmittals',
        'click .export-list': 'exportList',
        'click .btn-submittal-settings': 'editSettings',
        'click .btn-save-a-template': 'saveTemplate',
        'click .btn-import-template': 'importTemplate'
    },
    beforeFirstRender: async function () {
        this.isFetched = false;
        this.options.project = this.options.project ? this.options.project : PJQ.app.session.project;

        this.options.userSettings = await PJQ.app.session.fetchSubmittalUserSettings();
        if (this.options.project) {
            this.options.settings = await this.options.project.fetchSubmittalSettings();
            this.options.itemTypes = await this.options.project.fetchSubmittalItemTypes();
            this.options.customFields = await this.options.project.fetchSubmittalCustomFields();
            this.options.statuses = await this.options.project.fetchSubmittalStatuses();
        } else {
            this.options.settings = await PJQ.app.session.fetchSubmittalSettings();
            this.options.itemTypes = await PJQ.app.session.fetchSubmittalItemTypes();
            this.options.customFields = await PJQ.app.session.fetchSubmittalCustomFields();
            this.options.statuses = await PJQ.app.session.fetchSubmittalStatuses();
        }

        if (this.collection == null && this.options.project != null) {
            this.collection = new PJQ.collections.submittals.Submittals(null, {
                project: this.options.project
            });
            await this.collection.fetch();
        }

        this.isFetched = true;
        this.render();
    },
    beforeRender: function () {
        this.options.canAdd = this.options.project ? this.options.project.hasPermission('submittals.canAdd') : PJQ.app.session.hasPermission('settings.canManageSubmittals');
        this.options.isAdmin = this.options.project ? this.options.project.hasPermission('submittals.isAdmin') : PJQ.app.session.hasPermission('settings.canManageSubmittals');
    },
    renderData: function () {
        return {
            project: this.options.project,
            statuses: this.options.statuses
        };
    },
    afterRender: function () {
        if (!this.isFetched)
            return;

        this.renderDataTable();

        if (this.options.initSubmittalId > 0) {
            let initSubmittal = this.collection.get(this.options.initSubmittalId);
            if (initSubmittal != null) {
                this.options.initSubmittalId = null;
                this.editSubmittal(initSubmittal);
            }
        }
    },
    renderDataTable: function () {
        let self = this;
        this.dataTable = new PJQ.views.dataTables.DataTable({
            el: this.$(".submittals-table"),
            data: this.collection.models,
            rowId: "cid",
            order: [[2, 'desc']],
            pageLength: this.options.userSettings.getSettings(PJQ.constants.submittals.view.SUBMITTALS).rowsPerPage,
            orderCookie: PJQ.constants.cookies.SUBMITTAL_ORDER_COOKIE,
            settings: this.options.userSettings.getSettings(PJQ.constants.submittals.view.SUBMITTALS),
            language: {
                zeroRecords: 'Click "Add New Submittal" to create a new Submittal'
            },
            subTemplates: {
                header: new PJQ.templating.Template(PJQ.constants.modules.SUBMITTALS, 'Data-Table-Header-submittals')
            },
            headerData: () => {
                return {
                    canAdd: this.options.canAdd,
                    project: this.options.project,
                    statuses: this.options.statuses
                };
            },
            afterHeaderRender: (view, $header) => {
                let statuses = [],
                    addedPartial = false;
                _.each(_.sortBy(this.options.statuses.models, (status) => {
                    return status.get('sortOrder')
                }), (status) => {
                    if (this.options.settings.get('enableWorkflow')) {
                        if (status.get('type') !== PJQ.constants.submittals.statusTypes.SUBMITTED
                            && status.get('type') !== PJQ.constants.submittals.statusTypes.NEW) {
                            return;
                        }

                        statuses.push({
                            id: status.get('id'),
                            name: status.get('name'),
                            style: 'color: ' + PJQ.constants.submittals.statusTypeColors[status.get('type')]
                        });
                        return;
                    }

                    if (status.get('type') === PJQ.constants.submittals.statusTypes.APPROVED && !addedPartial) {
                        statuses.push({
                            id: '-1',
                            name: 'Partially Approved',
                            style: 'color: ' + PJQ.constants.colors.PURPLE
                        });
                        addedPartial = true;
                    }
                    statuses.push({
                        id: status.get('id'),
                        name: status.get('name'),
                        style: 'color: ' + PJQ.constants.submittals.statusTypeColors[status.get('type')]
                    });
                });

                let stChoices;
                if (this.options.settings.get('enableWorkflow')) {
                    statuses.push({
                        id: '-1',
                        name: 'Closed',
                        style: 'color: ' + PJQ.constants.colors.RED
                    });
                    stChoices = statuses;
                } else {
                    stChoices = [
                        {
                            name: 'Status',
                            choices: statuses
                        },
                        {
                            name: '',
                            choices: [
                                {
                                    id: '0',
                                    name: 'As Noted'
                                }
                            ]
                        }
                    ];
                }

                new PJQ.inputs.Selectpicker({
                    el: $header.find('.submittal-filter'),
                    onChange: function (value) {
                        view.setFilter('statusId', value);
                    },
                    choices: stChoices,
                    isIntChoices: true,
                    isMultiple: true,
                    noneSelectedText: 'No Filters'
                });
            },
            getFilterData: function (view, data) {
                let statusFilter = view.getFilter('statusId');
                if (_.size(statusFilter) === 0) {
                    return data;
                }

                let showPartial = _.contains(statusFilter, -1),
                    showAsNoted = _.contains(statusFilter, 0);

                // we only want the status filter to have actual statuses in it now
                statusFilter = _.filter(statusFilter, (statusId) => {
                    return statusId > 0;
                });
                return _.filter(data, function (row) {
                    let statusMatch = (statusFilter.length > 0 && _.contains(statusFilter, row.get('statusId')) && !row.get('isClosed'))
                        || (showPartial && row.isPartiallyApproved())
                        || (showPartial && row.get('isClosed'));
                    return statusMatch && (!showAsNoted || row.get('asNotedCommentId') > 0);
                });
            },
            onRowDoubleClick: _.bind(function (row) {
                this.editSubmittal(row.data());
            }, this),
            contextMenuOptions: {
                actions: [
                    {
                        name: 'Edit',
                        onClick: _.bind(function (row) {
                            this.editSubmittal(row.data());
                        }, this)
                    },
                    {
                        name: 'Delete',
                        isDanger: true,
                        onClick: _.bind(function (row) {
                            this.deleteSubmittal(row);
                        }, this)

                    }
                ]
            },
            columns: this.getColumns(false),
            colReorder: {
                fixedColumnsLeft: 0,
                fixedColumnsRight: 1,
                realtime: false
            },
            columnOrderChanged: _.bind(function () {
                if (this.options.userSettings != null) {
                    this.options.userSettings.save();
                }
            }, this)
        });

    },
    getColumns: function (includeAllColumns = false) {
        let columns = [], includeColumns = [],
            viewSettings = this.options.userSettings.getSettings(PJQ.constants.submittals.view.SUBMITTALS);

        if (includeAllColumns) {
            includeColumns = ["submittalNumber", "title", "itemTypes", "dueDate", "groupList", "submitter", "ballInCourt", "approverList", "distributionList", "status"];

            if (_.size(this.options.customFields) > 0) {
                _.each(this.options.customFields.models, function (customField) {
                    includeColumns.push('fieldValue' + customField.get('fieldNumber'));
                });
            }
        } else
            includeColumns = viewSettings.columns;

        _.each(includeColumns, _.bind(function (column) {
            if ((PJQ.app.session.project ? PJQ.app.session.project.preferences.getPref(PJQ.constants.preferenceTypes.HIDE_SUBMITTAL_ITEM_TYPE) : PJQ.app.session.preferences.getPref(PJQ.constants.preferenceTypes.HIDE_SUBMITTAL_ITEM_TYPE)) && column === 'itemTypes') {
                return;
            }
            switch (column) {
                case 'submittalNumber':
                    columns.push({
                        "columnData": "submittalNumber",
                        "title": "Number",
                        "data": {
                            "_": "attributes.submittalNumber",
                            "sort": _.bind(function (row) {
                                let number = parseInt(row.attributes.submittalNumber);
                                if (isNaN(number)) {
                                    return row.attributes.submittalNumber;
                                } else {
                                    return number
                                }
                            }, this),
                            "display": "attributes.submittalNumber"
                        },
                        'type': 'natural-ci',
                        'visible': viewSettings.columns.indexOf(column) !== -1
                    });
                    break;
                case 'title':
                    columns.push({
                        "columnData": "title",
                        "title": "Title",
                        "data": "attributes.title",
                        'visible': viewSettings.columns.indexOf(column) !== -1
                    });
                    break;
                case 'itemTypes':
                    columns.push({
                        "columnData": "itemTypes",
                        "title": "Item Types",
                        "data": "itemTypes",
                        "render": function (data, type, row) {
                            if (_.size(row.itemTypes.models) > 0) {
                                let itemTypeNames = [];
                                _.each(row.itemTypes.models, function (itemType) {
                                    itemTypeNames.push(itemType.get('name'));
                                });
                                return itemTypeNames.join(", ");
                            }
                            return '';
                        },
                        'visible': viewSettings.columns.indexOf(column) !== -1
                    });
                    break;
                case 'dueDate':
                    columns.push({
                        "columnData": "dueDate",
                        "title": "Due Date",
                        "data": "attributes.dueDate",
                        "render": (data, type, row) => {
                            if (data != null) {
                                let dueDate = new Date(data),
                                    dateString = PJQ.helpers.dateHelpers.getDateString(dueDate, PJQ.helpers.dateHelpers.dateFormats.DATE);
                                if (row.isNewStatus(this.options.statuses) && PJQ.helpers.dateHelpers.getDateDaysDiff(dueDate, new Date()) < 0) {
                                    return '<span class="text-danger font-weight-bold">' + dateString + '</span>';
                                }
                                return dateString;
                            }
                            return 'Not Set';
                        },
                        'visible': viewSettings.columns.indexOf(column) !== -1
                    });
                    break;
                case 'groupList':
                    columns.push({
                        "columnData": "groupList",
                        "title": "Groups",
                        "data": "groups",
                        "render": function (data, type, row) {
                            if (_.size(row.groups.models) > 0) {
                                let groupNames = [];
                                _.each(row.groups.models, function (group) {
                                    groupNames.push(group.get('groupName'));
                                });
                                return groupNames.join(", ");
                            }
                            return '';
                        },
                        'visible': viewSettings.columns.indexOf(column) !== -1
                    });
                    break;
                case 'submitter':
                    columns.push({
                        "columnData": "submitter",
                        "title": "Submitter",
                        "data": "submitter",
                        render: function (data, type, row) {
                            let result = '';
                            if (row.submitter != null) {
                                return PJQ.helpers.contacts.getContactAnchor({contact: row.submitter});
                            } else {
                                result = 'Nobody';
                            }
                            return result;
                        },
                        'visible': viewSettings.columns.indexOf(column) !== -1
                    });
                    break;
                case 'ballInCourt':
                    columns.push({
                        "columnData": "ballInCourt",
                        "title": "Ball In Court",
                        "data": "ballInCourt",
                        render: (data, type, row) => {
                            let result = [];

                            if (row.ballInCourt != null && !row.isVoidStatus(this.options.statuses)) {
                                result.push(PJQ.helpers.contacts.getContactAnchor({contact: row.ballInCourt}));
                            } else if (!this.options.settings.get('enableWorkflow') && row.isSubmittedStatus(this.options.statuses) || row.isPartiallyApproved()) {
                                result.push(this.options.settings.getApproveStatusName('ers'));
                            } else if (!row.get('isClosed') && this.options.settings.get('enableWorkflow') && row.isSubmittedStatus(this.options.statuses)) {
                                if(_.size(row.get('ballInCourtApproverList')) > 0) {
                                    _.each(row.get('ballInCourtApproverList'), function (contact) {
                                        result.push(PJQ.helpers.contacts.getContactAnchor({contact: contact}));
                                    });
                                } else {
                                    result.push(this.options.settings.getApproveStatusName('ers'));
                                }
                            } else {
                                result.push('Nobody');
                            }
                            return result.join(', ');
                        },
                        'visible': viewSettings.columns.indexOf(column) !== -1
                    });
                    break;
                case 'approverList':
                    columns.push({
                        columnData: 'approverList',
                        title: "Approver List",
                        render: function (data, type, row) {
                            let result = [];
                            if (_.size(row.get('approvers')) > 0) {
                                _.each(row.get('approvers'), function (contact) {
                                    result.push(PJQ.helpers.contacts.getContactAnchor({contact: contact}));
                                });
                            } else {
                                result.push('Nobody');
                            }
                            return result.join(', ');
                        },
                        visible: viewSettings.columns.indexOf(column) !== -1
                    });
                    break;
                case 'distributionList':
                    columns.push({
                        columnData: 'distributionList',
                        title: "Distribution List",
                        render: function (data, type, row) {
                            let result = [];
                            if (_.size(row.distributionList.models) > 0) {
                                _.each(row.distributionList.models, function (contact) {
                                    result.push(PJQ.helpers.contacts.getContactAnchor({contact: contact}));
                                });
                            } else {
                                result.push('Nobody');
                            }
                            return result.join(', ');
                        },
                        visible: viewSettings.columns.indexOf(column) !== -1
                    });
                    break;
                case 'status':
                    columns.push({
                        "columnData": "status",
                        "title": "Status",
                        "data": "attributes.statusId",
                        "render": _.bind(function (data, type, row) {
                            return '<span style="color:' + row.getStatusColor(this.options.statuses) + '">' + row.getStatusName(this.options.settings, this.options.statuses) + '</span>';
                        }, this),
                        'visible': viewSettings.columns.indexOf(column) !== -1
                    });
                    break;
                default:
                    if (column.startsWith('fieldValue')) {
                        _.each(this.options.customFields.models, function (customField) {
                            if (column === 'fieldValue' + customField.get('fieldNumber')) {
                                columns.push({
                                    "columnData": 'fieldValue' + customField.get('fieldNumber'),
                                    "title": customField.get('fieldName'),
                                    "className": [PJQ.constants.commitments.customFieldType.INTEGER, PJQ.constants.commitments.customFieldType.MONEY, PJQ.constants.commitments.customFieldType.PERCENT].indexOf(customField.get('fieldTypeId')) !== -1 ? "text-align-right" : "",
                                    'visible': viewSettings.columns.indexOf(column) !== -1,
                                    "render": function (data, type, row) {
                                        let fieldValue = row.getCustomFieldValue(customField.get('id'));
                                        fieldValue = (fieldValue !== null) ? fieldValue : '';
                                        switch (customField.get('fieldType')) {
                                            case 'BOOL':
                                                if (fieldValue != null)
                                                    fieldValue = fieldValue ? 'Yes' : 'No';
                                                break;
                                            case 'CHOICE':
                                                let choices = [];
                                                // convert single choice value into array so that the logic below can work for both types.
                                                if (typeof fieldValue === 'number')
                                                    fieldValue = [fieldValue];

                                                _.each(customField.choices.models, _.bind(function (choice) {
                                                    if (_.find(fieldValue, function (value) {
                                                        return value === choice.get('id');
                                                    }))
                                                        choices.push(choice.get('choiceName'));
                                                }, this));

                                                fieldValue = choices.join((', '));
                                                break;
                                            case 'DATE':
                                                if (fieldValue) {
                                                    if (type !== 'sort' && type !== 'type')
                                                        fieldValue = PJQ.helpers.dateHelpers.getDateString(new Date(fieldValue), PJQ.helpers.dateHelpers.dateFormats.DATE, true);
                                                }
                                                if (fieldValue === undefined)
                                                    fieldValue = '';

                                                break;
                                            case 'DATETIME':
                                                if (fieldValue) {
                                                    if (type !== 'sort' && type !== 'type')
                                                        fieldValue = PJQ.helpers.dateHelpers.getDateString(new Date(fieldValue), PJQ.helpers.dateHelpers.dateFormats.DATE_TIME, false);
                                                }
                                                if (fieldValue === undefined)
                                                    fieldValue = '';

                                                break;
                                            case 'INT':
                                                if (type !== 'sort' && type !== 'type' && fieldValue) {
                                                    fieldValue = parseInt(fieldValue).toLocaleString();
                                                }
                                                break;
                                            case 'MONEY':
                                                if (type === 'sort' || type === 'type') {
                                                    if (fieldValue && fieldValue !== '$')
                                                        fieldValue = parseFloat(PJQ.helpers.formatHelpers.numbersOnly(fieldValue, true));
                                                    else
                                                        fieldValue = 0;
                                                } else {
                                                    fieldValue = PJQ.helpers.formatHelpers.formatCurrency(parseInt(PJQ.helpers.formatHelpers.numbersOnly(fieldValue)));
                                                }
                                                break;
                                            case 'PERCENT':
                                                if (type === 'sort' || type === 'type') {
                                                    if (!fieldValue)
                                                        fieldValue = 0;
                                                } else {
                                                    fieldValue = fieldValue ? PJQ.helpers.formatHelpers.formatCurrency(parseInt(PJQ.helpers.formatHelpers.numbersOnly(fieldValue)), 2, false) + '%' : '';
                                                }
                                                break;
                                        }

                                        return fieldValue;
                                    }
                                });
                            }
                        });
                    }
                    break;
            }
        }, this));

        if (!includeAllColumns) {
            columns.push({
                "data": "",
                "title": "",
                "orderable": false,
                "searchable": false,
                "width": '80px',
                "render": _.bind(function () {
                    let html = '<div class="show-on-row-hover"><button type="button" class="btn btn-info btn-edit-submittal"><i class="fal fa-pencil"></i></button>';
                    if (this.options.isAdmin) {
                        html += '<button type="button" class="btn btn-danger btn-delete-submittal ml-1"><i class="fal fa-trash"></i></button>';
                    }
                    html += '</div>';
                    return html;
                }, this)
            });
        }

        return columns;
    },
    addClicked: function () {
        this.editSubmittal(null);
    },
    editClicked: function (e) {
        let target = $(e.currentTarget),
            row = this.dataTable.getRow(target.closest('tr')),
            submittal = row.data();
        this.editSubmittal(submittal);
    },
    editSubmittal: function (submittal) {
        new PJQ.views.submittals.EditSubmittalModal({
            model: submittal,
            templateId: this.model ? this.model.get('templateId') : null,
            project: this.options.project,
            onSave: (model, isNew) => {
                if (isNew) {
                    this.collection.add(model);
                    this.dataTable.addRow(model);
                }
                this.dataTable.refresh();
            },
            onClose: () => {
                this.dataTable.refresh();
            },
            onDelete: (submittal) => {
                let row = this.dataTable.getRow(submittal.cid);
                if (row != null) {
                    this.dataTable.removeRow(row);
                }
                submittal.destroy();
            }
        }, this)
    },
    deleteClicked: function (e) {
        let target = $(e.currentTarget),
            row = this.dataTable.getRow(target.closest('tr'));
        this.deleteSubmittal(row);
    },
    deleteSubmittal: function (row) {
        let submittal = row.data();
        new PJQ.views.modals.DeleteCancel({
            header: "Confirm Delete",
            body: "Are you sure you want to delete this Submittal?",
            onDelete: _.bind(function () {
                submittal.destroy();
                this.dataTable.removeRow(row);
            }, this)
        });
    },
    editSettings: function () {
        new PJQ.views.submittals.SettingsModal({
            submittalsView: this,
            model: this.options.settings,
            userSettings: this.options.userSettings,
            project: this.options.project ? this.options.project : null,
            onSave: _.bind(function () {
                this.renderDataTable();
            }, this)
        });
    },
    saveTemplate: function () {
        new PJQ.views.submittals.SubmittalTemplateCreatorModal({
            collection: this.collection,
            project: this.options.project
        });
    },
    importTemplate: function () {
        new PJQ.views.submittals.ImportTemplateModal({
            project: this.options.project,
            onImport: _.bind(function (submittals) {
                this.collection = submittals;
                this.render();
            }, this)
        });
    },
    exportSubmittals: function () {
        new PJQ.ajax.Request({
            endpoint: this.options.project.endpoint() + '/submittals/export',
            data: {
                isApi2: true
            }
        }).post().done(_.bind(function (response) {
            PJQ.files.downloadFile(response.url, {
                isEndpoint: false
            });
        }, this)).fail(_.bind(function (xhr, err, result) {
        }, this));
    },
    exportList: function () {
        if (this.options.project == null) {
            return;
        }

        let orderCookie = PJQ.helpers.cookieHelpers.getCookie(PJQ.constants.cookies.SUBMITTAL_ORDER_COOKIE),
            order = orderCookie != null ? JSON.parse(orderCookie) : null,
            report = new PJQ.models.reports.NewReport({
                type: PJQ.constants.reports.reportTypes.SUBMITTAL.type,
                projectId: this.options.project ? this.options.project.id : null,
                options: {
                    columns: this.options.userSettings.getSettings(PJQ.constants.submittals.view.SUBMITTALS).columns,
                    columnOrder: order
                }
            });
        report.export({format: 'excel'}).then(() => {

        });
    },
});

PJQ.views.submittals.EditHistoryModal = PJQ.views.BaseModal.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.SUBMITTALS, 'edit-history-modal'),
        subTemplates: {
            history: new PJQ.templating.Template(PJQ.constants.modules.SUBMITTALS, 'edit-history'),
        },
        width: '50%',
        maxWidth: 700,
        onSave: _.noop
    },
    events: {},
    afterRender: function () {
        this.renderHistory()
    },
    renderHistory: function () {
        this.renderSubTemplate(false, this.options.subTemplates.history, this.$('.history-outer'), {
            history: this.options.history.models.reverse()
        });
    }
});

PJQ.views.submittals.FileEditorModal = PJQ.views.BaseModal.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.SUBMITTALS, 'modal-file-editor'),
        isNewVersion: false,
        isNoteEdit: false
    },
    events: {
        'click .btn-save': 'save'
    },
    beforeRender: function () {
        this.renderData = {
            model: this.model,
            isNoteEdit: this.options.isNoteEdit,
            isNewVersion: this.options.isNewVersion
        };
    },
    afterRender: function () {
        new PJQ.Binder(this.$el, this.model, {
            watchElements: [
                'textarea'
            ]
        });
        this.fileUploader = new PJQ.views.files.FileUploaderGrid({
            el: this.$('.submittal-file-uploader'),
            collection: this.collection,
            style: 'list',
            canUpload: (this.collection.models.length === 0 || !this.options.isNewVersion),
            canDelete: true,
            canDownload: true,
            isRemoveOnComplete: this.options.isNewVersion,
            previewImageDimension: 150,
            onSuccess: _.bind(function () {
                if (this.options.isNewVersion) {
                    this.render();
                }
            }, this),
            onDelete: _.bind(function (attachment, callback) {
                if (attachment.id > 0) {
                    attachment.set('isDeleted', true);
                } else {
                    attachment.destroy();
                }
                this.model.isDirty = true;
                callback();
            }, this)
        });
    },
    save: function () {
        if (this.options.isNewVersion) {
            this.collection.add(this.model);
        }

        this.options.onSave(this.collection);
        this.removeModal();
    }
});

PJQ.views.submittals.StatusChangeCommentModal = PJQ.views.BaseModal.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.SUBMITTALS, 'modal-status-change-comment'),
        title: null
    },
    events: {
        'click .btn-save': 'save'
    },
    renderData: function () {
        return {
            model: this.model,
            title: this.options.title
        }
    },
    afterRender: function () {
        new PJQ.Binder(this.$el, this.model, {
            watchElements: [
                'textarea'
            ]
        });

        new PJQ.inputs.Datepicker({
            el: this.$('.input-due-date'),
            datepickerOptions: {
                format: PJQ.helpers.dateHelpers.dateFormats.datePicker.DATE,
                defaultDate: this.model.get('dueDate') ? new Date(this.model.get('dueDate')) : null
            },
            onChange: _.bind(function (newDate) {
                this.model.set('dueDate', newDate);
            }, this)
        });
    },
    save: function () {
        let val = this.$('.item-status-change-comment').val().trim();
        if (_.size(val) === 0) {
            this.options.onSave(this.model, null);
            this.removeModal();
        } else {
            let comment = new PJQ.models.submittals.Comment({
                submittalId: this.model.id,
                comment: val,
                createdOn: new Date(),
                asNoted: true
            });
            this.model.comments.add(comment);
            this.options.onSave(this.model, comment);
            this.removeModal();
        }
    }
});
